import styled from 'styled-components';
import { Row } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

export const TileRow = styled(Row)`
  padding: ${({ theme }) => theme.x2spacePx}px 0;
  margin: 0 -${({ theme }) => theme.x2spacePx}px;
  ${media.mdDown`
    margin: 0 -${({ theme }) => theme.x1spacePx}px;
  `};
`;

export const TileViewContainer = styled('section')`
  ${media.mdDown`
    margin-left: ${({ theme }) => theme.x2spacePx}px;
    margin-right: ${({ theme }) => theme.x2spacePx}px;
  `};
`;
